// src/components/workshop-hub/WorkshopHub.tsx
"use client";

import { useState, SyntheticEvent } from "react";
import {
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { useUser } from "@/contexts/UserContext"; // Đảm bảo đường dẫn đúng
import WorkshopsTab from "./components.tsx/WorkshopsTab";
import MyProposedWorkshopsTab from "./components.tsx/MyProposedWorkshopsTab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function WorkshopHub() {
  const [value, setValue] = useState(0); // State để quản lý tab đang chọn (0 cho Workshops, 1 cho My Proposed)
  const { user } = useUser();
  const navigate = useNavigate();

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const isAdminOrOrg = user?.is_admin || user?.is_org;
  console.log((user?.user_login && !isAdminOrOrg))
  return (
    <Container maxWidth="xl">
      {/* Header Section */}
      <Box sx={{ mb: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 3,
          }}
        >
          <Box>
            <Typography variant="h2" gutterBottom fontWeight={500}>
              EduCatalyst Workshops
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Discover, learn, and connect with educators worldwide.
            </Typography>
          </Box>
          {(user?.user_login == null || typeof user?.user_login == "undefined") ? (
            <></>
          ) : (user?.role == "educator" || isAdminOrOrg) ? (
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => navigate("./creation")}
              >
                Create Workshop
              </Button>
            </Stack>
          ): (
            <></>
          )}
        </Box>

        {/* Tabs Navigation */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
          <Tabs value={value} onChange={handleChange} aria-label="workshop tabs">
            <Tab label="Workshops" {...a11yProps(0)} />
            {(user?.user_login && user?.role == "educator") && <Tab label="My Submitted Proposal" {...a11yProps(1)} />}
          </Tabs>
        </Box>
      </Box>

      {/* Tab Panels */}
      <CustomTabPanel value={value} index={0}>
        <WorkshopsTab /> {/* Render WorkshopsTab */}
      </CustomTabPanel>
      {(user?.user_login && !isAdminOrOrg) && (
        <CustomTabPanel value={value} index={1}>
          <MyProposedWorkshopsTab username={user.user_login} /> {/* Render MyProposedWorkshopsTab và truyền userId */}
        </CustomTabPanel>
      )}
    </Container>
  );
}